var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-info-container"},[_c('v-icon',{attrs:{"size":"120"}},[_vm._v("mdi-cards-outline")]),_c('h1',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }